import React from 'react';

import { Box } from '@mui/system';
import { Button, Typography } from '@mui/material';

import useUpdateCardDetails from '../../../../../../hooks/Payment/useUpdateCardDetails';
import { Constants } from '../../../../../../helpers/Constants';
import strings from '../../../../../../localization';

import styles from './styles';
import SavedCard from './SavedCard';

const SavedPlanDetails = () => {
  const { updatePaymentMethod } = useUpdateCardDetails();

  return (
    <Box sx={styles.container}>
      <Box sx={styles.subContainer}>
        <Box>
          <SavedCard />
        </Box>
        <Button
          sx={styles.button}
          variant={Constants.variant.text}
          onClick={updatePaymentMethod}
        >
          <Typography sx={styles.link}>
            {strings.updatePaymentDetails}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default SavedPlanDetails;
